import chongzhi from './chongzhi'
import wxapi from './wxapi'
import login from './login'
import marketing from './marketing'
import common from './common'
const api = {
    ...chongzhi,
    ...wxapi,
    ...login,
    ...marketing,
    ...common
}

export default api;


// WEBPACK FOOTER //
// ./src/Interface/api/index.js